/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/23/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Grid} from '@scuf/common';
import SearchInput from '../common/SearchInput'
import SortInput from "../common/SortInput";

class Filter extends React.Component {

    render() {
        const {intl} = this.props

        return (
            <div className={this.props.className}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={5} sWidth={12}>
                            <SearchInput value={this.props.search} placeholder={intl.formatMessage({id: "filter.search"})} fluid onChange={this.props.searchChanged}/>
                        </Grid.Column>
                        <Grid.Column width={3} sWidth={12}>
                            <SortInput value={this.props.sort} sortOptions={this.props.sortOptions} onChange={this.props.sortChanged}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

export default injectIntl(Filter)